import { render, staticRenderFns } from "./HistoryTableHeader.vue?vue&type=template&id=15538653&scoped=true&"
import script from "./HistoryTableHeader.vue?vue&type=script&lang=js&"
export * from "./HistoryTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTableHeader.vue?vue&type=style&index=0&id=15538653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15538653",
  null
  
)

export default component.exports